// noinspection JSUnusedGlobalSymbols

export enum Env {
    Development = 'development',
    Production = 'production',
    Test = 'test',
}

export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
}

export enum RouteName {
    Login = 'Login',
    Register = 'Register',
    Dashboard = 'Dashboard',
    Profile = 'Profile',
    NotFound = 'NotFound',
}

export enum UserRole {
    Admin = 'ADMIN',
    CUSTOMER = 'CUSTOMER',
    COMPANY = 'COMPANY',
}

export enum ApiStatus {
    Success = 'success',
    Error = 'error',
    Pending = 'pending',
}

export enum StorageKey {
    Theme = 'theme',
    UserPreferences = 'user_preferences',
}

export enum ThemeMode {
    Light = 'light',
    Dark = 'dark',
    System = 'system',
}

export enum Breakpoint {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
}

export enum SortOrder {
    Asc = 'asc',
    Desc = 'desc',
}

export enum Marketplace {
    Trendyol = 'Trendyol',
    Hepsiburada = 'Hepsiburada',
    N11 = 'N11',
    Amazon = 'Amazon',
}

export enum QuestionStatus {
    WAITING_FOR_ANSWER,
    WAITING_FOR_APPROVE,
    UNANSWERED,
    ANSWERED,
    REPORTED,
    REJECTED,
    WAITING_FOR_AI_ANSWER,
    WAITING_FOR_SUPPLIER_REVIEW
}

export enum UserType {
    Admin,
    CUSTOMER,
    COMPANY
}

export enum ConversationProvider {
    MARKETPLACE = 'MARKETPLACE',
    WHATSAPP = 'WHATSAPP',
    MESSENGER = 'MESSENGER',
    INSTAGRAM = 'INSTAGRAM'
}
